// Func = limiting Scope for this file
var lastScrollTop = 0;
(function() {

    document.addEventListener('DOMContentLoaded', () => {

        // Remove Footer mask when the last content is Room tag Filter shortcode
        if ($(".processed-content section:last").hasClass("rooms-filter-tag") || $(".processed-content section:last").hasClass("rooms-list") || $(".processed-content section:last").hasClass("double-quad")) {
            $("footer").addClass("remove-mask");
        } 

        $('.historical-menu-item').click(function() {
            let slideIndex = $(this).data('artwork');
            $(".history-slides").slick('slickGoTo', parseInt(slideIndex));

        });

        $(".history-slides").on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            let item = $('.historical-menu-item')[nextSlide];
            $('.historical-menu-item').removeClass('active');
            item.classList.add('active');
        });


        //Open Booking Content
        if(document.querySelector('.open-booking')) {
            let openBookingBtn = document.querySelector('.open-booking');
            openBookingBtn.addEventListener('click', ( e ) => {
                e.preventDefault();
                openBookingBtn.classList.add('open');
                document.querySelector('#booking-section').classList.add('open')
            })
        }

        // Close Booking Content
        $('.close-booking').click(function(event) {
            event.preventDefault();
            $('.open-booking').removeClass('open');
            $('#booking-section').removeClass('open');
        }); 
        // Select Property
        // $('#booking-section .booking-select-hotel li').click(function(event) {
        //     event.preventDefault();
        //     $('#booking-form').addClass('open');
        //     $('.booking-select-hotel').addClass('hide');
        //     $('.back-to-select').show();
        // });
        // // Back to select a property
        // $('.back-to-select').click(function(event) {
        //     event.preventDefault();
        //     $('#booking-form').removeClass('open');
        //     $('.booking-select-hotel').removeClass('hide');
        //     $(this).hide();
        // });

        if ($('#booking-form').length > 0) {
            let categotyInput = document.createElement('input');
            categotyInput.setAttribute('id', 'bookingCategory');
            categotyInput.setAttribute('name', 'roomcategoryid');
            categotyInput.setAttribute('type', 'hidden');
            document.getElementById('booking-form').appendChild(categotyInput)
        }

        // Get the action Url for each Property
        $("#booking-section .booking-select-hotel li").each(function() {
            $(this).on("click", function() {
                var action_url = $(this).attr('value');
                $("#booking-form").attr('action', action_url.split('=')[0]);
                $('#bookingCategory').attr('value', action_url.split('=')[1])

            });
        })



        //Open Navigation
        $('#menu-btn').click(function(event) {
            event.preventDefault();
            $('body').addClass('open');
            $('.burger-menu').addClass('open');
            $('.menu-content').addClass('open');
        });

        $('.close-menu').click(function(event) {
            event.preventDefault();
            $('body').removeClass('open');
            $('.burger-menu').removeClass('open');
            $('.menu-content').removeClass('open');
        });


        /*****************************************************
         OBSERVER TO ADD PARALLAX EFFECT
         /*****************************************************/
        var scrollParallax = []
        var scrolled = 0

        // screen height
        var v_height = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;

        function doParallax(elm) {

            let boundes = elm.dataset.parallax.split(",") // get it from html
                //get distance in positive value
            let distance = Math.abs(boundes[0] - boundes[1])
            if (boundes[0] > boundes[1]) {
                //get distance in negative value (to do the scroll inverse)
                distance = distance * -1
            }
            //Equivalent distance using screen height + element height
            const unit_scroll = distance / (v_height + elm.offsetHeight)
            let temp = 0

            let topElement = 0;
            let element = elm;

            let id_elem = elm.dataset.parallaxid

            do {
                topElement += element.offsetTop || 0;
                element = element.offsetParent;
            } while (element)

            let parallaxFunction = function() {
                //Obtain the distance between top screen and document top 0
                scrolled = document.documentElement.scrollTop || window.pageYOffset
                    //Distance of bottom page to top of the element
                let relative_distance = scrolled + v_height - topElement
                    //transpoling data to move the parallax element relative to the scroll of all the screen
                temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
                    //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
                elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
            }

            scrollParallax[id_elem] = parallaxFunction

            window.addEventListener('scroll', scrollParallax[id_elem])

        }

        let observers_parallax = document.querySelectorAll(".js-parallax-element")

        if (observers_parallax) {
            let options_parallax = {
                root: null, // relative to document viewport
                rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
                threshold: 0 // visible amount of item shown in relation to root
            }

            function handler_parallax(entries, observer) {
                let entry;
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        doParallax(entry.target)
                    } else {
                        let id_elem = entry.target.dataset.parallaxid
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }
                })
            }

            let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
            let counter = 1
            observers_parallax.forEach(function(element) {
                observable_parallax.observe(element)
                element.dataset.parallaxid = counter
                counter++
            })
        }
        /********************************************************************************
         END OF OBSERVER TO ADD PARALLAX EFFECT
         ***********************************************************************************/




        //vanilla js scroll animation

        function animateTo(target) {
            var gotoTarget = offset(document.getElementById(target)).top - 20;
            var from = window.pageYOffset;
            var to = gotoTarget;
            var duration = 1300;
            var start = new Date().getTime();

            //time interval
            var timer = setInterval(function() {
                var time = new Date().getTime() - start;

                if (from <= to) {
                    var y = easeInOutQuart(time, from, to - from, duration)
                } else {

                    var y = easeInOutQuart(time, from, -(from - to), duration)
                }
                window.scrollTo(0, y)
                if (time >= duration) clearInterval(timer)

            }, 1000 / 60);

            window.scrollTo(0, from)

        }


        //ease movement
        function easeInOutQuart(t, b, c, d) {
            if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
            return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
        }



        // Call function with browser is resized.
        // $(window).resize(function (event) {
        // 	resizeWindow();
        // });
        // resizeWindow();

        // Main Nav Dropdown
        $("#primary-nav li").hover(function() {
            $(this).addClass("hover");
            $('ul.submenu', this).fadeIn(200);
        }, function() {
            $(this).removeClass("hover");
            $('ul.submenu', this).fadeOut(200);
        });

        // Main Nav Active
        $("#primary-nav li a").click(function() {
            $(this).addClass("active");
        }, function() {
            $(this).removeClass("active");
        });

        //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
        let DATE_STYLE = [true];

        function calendarRange(date) {
            let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
            let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
            if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
                DATE_STYLE[1] = 'highlight-top';
            } else if (date > d1 && date < d2) {
                DATE_STYLE[1] = 'highlight';
            } else {
                DATE_STYLE[1] = '';
            }
            return DATE_STYLE;
        }

        $('.open-booking-widget-inline-date').on('click', function(e) {
            $("#adults").val(2);
            $("#child").val(0);
            $("#number_guest").text("2 ADULTS");
        });

        //Check in and check out datepicker for booking engine
        const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";
        $("#CheckIn").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
            minDate: 0,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $("#CheckOut").datepicker("setDate", newDate);
                $("#CheckOut").datepicker("option", "minDate", selectedDate);
            }
        });
        $("#CheckOut").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
            numberOfMonths: 1,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function(selectedDate) {
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            }
        });
        // Map: Return to previous page button. Change body id to match map template's name.
        //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');



        // Map: Return to previous page button. Change body id to match map template's name.
        //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
    })
    // $(document).ready(function() {



    // });

    window.onload = function() {
        /*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */

        // scrollDownAction(20, 'scroll');

        scrollW();
        window.addEventListener('scroll', function() {
            scrollW();
        })
    };

}());

function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 80) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    var lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}